import { Injectable } from '@angular/core';
import { IRenameDataSave } from '@app/modules/table/children/table-column-action/interfaces/table-column-action.interface';
import { Subject } from 'rxjs';

/**
 * Сервис действий над столбцами таблицы
 * Предназначен для обмена данными между компонентами
 */
@Injectable()
export class TableColumnActionService {
    /** Данные для изменения названия столбца */
    eventNewColumnName$: Subject<IRenameDataSave> = new Subject();
}
